import { Injectable } from '@angular/core';
import { convertionAmount, ConvertionApp, convertionCurrency } from './google-analitycs.config';
declare let gtag: Function;

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalitycsService {
  constructor() {}

  trackPage(payload = {}) {
    if (typeof gtag != 'undefined') {
      gtag('event', 'page_view', payload);
    }
  }
  

  trackConversion(code: string) {
    if (typeof gtag != 'undefined') {
      gtag('event', 'conversion', { send_to: 'AW-11410335507/uxggCNzNovYZEJPO78Aq' });
      
    }
  }

  trackConversionUSD() {
    if (typeof gtag != 'undefined') {
      gtag('event', 'conversion', { send_to: 'AW-11410335507/uxggCNzNovYZEJPO78Aq' });
    }
  }

  trackConversionProgrammatic() {
    if (typeof gtag != 'undefined') {
      gtag('event', 'conversion', {
        allow_custom_scripts: true,
        send_to: 'DC-11324528/invmedia/pe_pi0+standard',
      });
    }
  }
}
